/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnEventStatus } from './en-event-status';
import { EnProgramType } from './en-program-type';
import { JoinEntityDto } from './join-entity-dto';
import { MobilityDto } from './mobility-dto';
import { ProfileDto } from './profile-dto';
import { ProgramDto } from './program-dto';
 /**
 *
 *
 * @export
 * @interface AssignmentDto
 */
export interface AssignmentDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof AssignmentDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof AssignmentDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof AssignmentDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof AssignmentDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof AssignmentDto
     */
    startAt: string;

    /**
     * @type {string}
     * @memberof AssignmentDto
     */
    endAt: string;

    /**
     * @type {EnEventStatus}
     * @memberof AssignmentDto
     */
    status: EnEventStatus;

    /**
     * @type {number}
     * @memberof AssignmentDto
     */
    progress: number;

    /**
     * @type {string}
     * @memberof AssignmentDto
     */
    title: string | null;

    /**
     * @type {MobilityDto}
     * @memberof AssignmentDto
     */
    mobility: MobilityDto | null;

    /**
     * @type {EnProgramType}
     * @memberof AssignmentDto
     */
    type: EnProgramType | null;

    /**
     * @type {ProfileDto}
     * @memberof AssignmentDto
     */
    user: ProfileDto;

    /**
     * @type {JoinEntityDto}
     * @memberof AssignmentDto
     */
    client: JoinEntityDto | null;

    /**
     * @type {ProgramDto}
     * @memberof AssignmentDto
     */
    program: ProgramDto | null;

    /**
     * The protocol this therapy was composed from, if any (provenance).
     *
     * @type {JoinEntityDto}
     * @memberof AssignmentDto
     */
    protocol: JoinEntityDto | null;

    /**
     * The catalog template this therapy was derived from, if any (provenance). Unlike `program`, it is also set when the practitioner tweaked the template before assigning — the case where `program` is null because the edited graph was sent inline and never persisted to the catalog.
     *
     * @type {JoinEntityDto}
     * @memberof AssignmentDto
     */
    sourceProgram: JoinEntityDto | null;

    /**
     * @type {JoinEntityDto}
     * @memberof AssignmentDto
     */
    rescheduled: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof AssignmentDto
     */
    creator: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof AssignmentDto
     */
    operator: JoinEntityDto;

    /**
     * @type {string}
     * @memberof AssignmentDto
     */
    note?: string | null;
}
